import { TListingTableRow, NewListing } from "@protoplan/types";
import { IPriceUpdateStatus } from "../types/priceUpdateStatus";
import { axiosInstance } from "./axiosInstance";


export async function getNListings()
{
  return axiosInstance.post("/listings/nListings")
    .then(resJson => resJson.data)
    .catch(error => console.log("Error retrieving nListings", error));
}

export async function getListings(productId: number, protocolId: number)
{
  return axiosInstance.post("/listings/listings", { productId, protocolId })
    .then(resJson => resJson.data as TListingTableRow[])
    .catch(error => console.log("Error retrieving listings for product id", productId, ":", error));
}

export async function getListing(listingId: number)
{
  return axiosInstance.post("/listings/listing", { listingId })
    .then(resJson => resJson.data as TListingTableRow | undefined)
    .catch(error => console.log("Error retrieving listing of listingId ", listingId, ":", error));
}

export async function getVendors()
{
  return axiosInstance.post("/listings/vendors")
    .then(resJson => resJson.data)
    .catch(error => console.log("Error retrieving vendors", error));
}

export async function postNewListing(listing: NewListing)
{
  return axiosInstance.post("/listings/newListing", { 'New-listing': listing })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error posting new listing", error));
}

export async function deleteListing(listingId: number)
{
  return axiosInstance.post("/listings/deleteListing", { 'Delete-listing': listingId })
    .catch(error => console.log("Error deleting listing", error));
}

export async function updatePrice(listingId: number, price: number)
{
  return axiosInstance.post("/listings/updatePrice", { listingId, price })
    .catch(error => console.log("Error updating listing price", error));
}

export async function getPriceUpdateStatus()
{
  return axiosInstance.post("/listings/priceUpdateStatus")
    .then(resJson => (resJson.data as {
      vimergyListings: IPriceUpdateStatus,
      listings: IPriceUpdateStatus,
      doseListings: IPriceUpdateStatus,
      userDosingListings: IPriceUpdateStatus  }))
    .catch(error => console.log("Error getting price scrape status", error));
}